import Decimal from "decimal.js";
import { atom } from "recoil";
import { MixSpotAccountSelector } from "store/spot/SpotAccount";
import { selectorWithoutCache as selector } from "util/RecoilWithoutCache";
import {
  SpotConfig,
  MixSpotTabTypeState,
  MixSpotCrossAccountsDebtSelector,
} from "./../data/Spot";
import { parseFloatNumber } from "components/Spot/components/utils/utils";

export const platskCoin = "BGB";

export const MixSpotCrossBgbDeductionAccountsState = atom({
  key: "mix-spot-platsk-deduction-cross-accounts-state",
  default: [],
});
// 币种列表 - 用于计算杠杆风险率排出计算币种所用
export const MixMarginRiskRatioCoinListState = atom({
  key: "mix-margin-risk-ratio-coin-list-atom",
  default: [],
});
// platsk余额 - 现货 全仓 逐仓 资产列表的 platsk余额 全仓杠杆BGB余额/现货BGB余额
export const MixSpotMarginBgbNumSelector = selector({
  key: "mix-spot-margin-platsk-num-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    const spotAssets = get(MixSpotAccountSelector);
    const crossAssets = get(MixSpotCrossAccountsDebtSelector); // 全仓订阅的资产
    const crossAssetsEctype = get(MixSpotCrossBgbDeductionAccountsState); // 逐仓订阅的全仓资产
    // crossAssets 和 crossAssetsEctype 都是取自ws全仓资产，赋值给不同数据源
    if (tabType === "spot") {
      // 单独过滤出BGB的数据 --- 取现货资产列表platsk的数据
      let objs = null;
      for (let key in spotAssets) {
        const keyCoin = key.toUpperCase();
        if (keyCoin == platskCoin) {
          objs = spotAssets[key];
        }
      }
      const available =
        new Decimal(objs?.available || 0)
          .sub(objs?.limitAvailable || 0)
          .toFixed(2, Decimal.ROUND_DOWN) || 0;
      return available ? parseFloatNumber(available) : "0";
    } else {
      const assetsArry = tabType == "cross" ? crossAssets : crossAssetsEctype;
      let objs = null;
      assetsArry.forEach((element) => {
        const keyCoin = element?.tokenId?.toUpperCase();
        if (keyCoin == platskCoin) {
          objs = element;
        }
      });
      const val =
        new Decimal(objs?.free || 0).toFixed(2, Decimal.ROUND_DOWN) || 0;
      return val ? parseFloatNumber(val) : "0";
    }
    // return '0'
  },
});
//  else if (tabType === 'isolated') {
//     // 单独过滤出BGB的数据  --- 取逐仓资产列表platsk的数据
//     let arrys = []
//     let objs = null
//     for (let key in isolatedAssets) {
//         const keyCoin = key.toUpperCase()
//         // 和产品沟通 写死platskusdt的
//         if (keyCoin == 'BGBUSDT') {
//             arrys = isolatedAssets[key]
//         }
//     }
//     arrys.forEach(element => {
//         const keyCoin = element?.tokenId?.toUpperCase()
//         if (keyCoin == 'BGB') {
//             objs = element
//         }
//     });
//     const val = new Decimal(objs?.free || 0).toFixed(2, Decimal.ROUND_DOWN) || 0
//     return val ? parseFloatNumber(val) : '0'
// }

// else if (tabType === 'cross') {
//     // 单独过滤出BGB的数据 --- 取全仓资产列表platsk的数据 - 全仓用
//     let objs = null
//     crossAssets.forEach(element => {
//         const keyCoin = element?.tokenId?.toUpperCase()
//         if (keyCoin == platskCoin) {
//             objs = element
//         }
//     });
//     const val = new Decimal(objs?.free || 0).toFixed(2, Decimal.ROUND_DOWN) || 0
//     return val ? parseFloatNumber(val) : '0'
// } else if (tabType === 'isolated') {
//     // 单独过滤出BGB的数据 --- 取全仓资产列表platsk的数据 - 逐仓用
//     let objs = null
//     crossAssetsEctype.forEach(element => {
//         const keyCoin = element?.tokenId?.toUpperCase()
//         if (keyCoin == platskCoin) {
//             objs = element
//         }
//     });
//     const val = new Decimal(objs?.free || 0).toFixed(2, Decimal.ROUND_DOWN) || 0
//     return val ? parseFloatNumber(val) : '0'
// }
